import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { TextMosaic, TextMosaicDto, MosaicWall } from '@ami/react/core';
import { couplerDecision } from '../../../quotes/otherQuoteEntities';
import { QuoteCouplerStyle } from '../../../quotes/quoteProductConfiguration';
import ReviewQuoteExistingCouplerSelection from './ReviewQuoteExistingCouplerSelection';

const ReviewQuoteCouplerDecisionModalContent = ({
  attachmentPoint,
  anyCouplerAffected,
  decision,
  couplerStyleId,
  couplerOilReady,
  defaultCouplerType,
  showExistingCouplerSelection,
  couplerStyles,
  onStateChanged,
  productGroupIdsPerType,
  showAmiCoupler,
  showDecideLater,
  isNarrowLayout,
  currentManufacturer,
}) => (
  <Fragment>
    <div
      className={`row justify-content-center quote-lugging-selection mt-4 ${
        decision !== null ? '' : 'invalid'
      }`}
      placeholder="Please specify a lugging selection"
    >
      <div className={`col ${isNarrowLayout ? '' : 'col-md-12'}`}>
        {!anyCouplerAffected && (
          <Fragment>
            <div className="row text-center">
              <MosaicWall childrenContainerClassName="row d-flex justify-content-center">
                {attachmentPoint.compatibleCouplerDecisions.find(
                  (x) => x === couplerDecision.directPinOn
                ) && (
                  <TextMosaic
                    data={
                      new TextMosaicDto({
                        label: (
                          <div>
                            <div>Direct Pin On</div>
                            <div>Attachments</div>
                          </div>
                        ),
                        selected: decision === couplerDecision.directPinOn,
                      })
                    }
                    onClick={() =>
                      onStateChanged({
                        decision: couplerDecision.directPinOn,
                        couplerStyleId: null,
                        couplerOilReady: null,
                      })
                    }
                    widthColumns={4}
                    mdWidthColumns={isNarrowLayout ? 4 : 2}
                  />
                )}
                {attachmentPoint.compatibleCouplerDecisions.find(
                  (x) => x === couplerDecision.amiCoupler
                ) &&
                  showAmiCoupler &&
                  couplerStyles.length > 0 && (
                    <TextMosaic
                      data={
                        new TextMosaicDto({
                          label: (
                            <div>
                              <div>Need a</div>
                              <div>Coupler</div>
                            </div>
                          ),
                          selected: decision === couplerDecision.amiCoupler,
                        })
                      }
                      onClick={() =>
                        onStateChanged({
                          decision: couplerDecision.amiCoupler,
                          couplerStyleId: null,
                          couplerOilReady: null,
                        })
                      }
                      widthColumns={4}
                      mdWidthColumns={isNarrowLayout ? 4 : 2}
                    />
                  )}
                {attachmentPoint.compatibleCouplerDecisions.find(
                  (x) => x === couplerDecision.existingCoupler
                ) &&
                  couplerStyles.length > 0 && (
                    <TextMosaic
                      data={
                        new TextMosaicDto({
                          label: (
                            <div>
                              <div>Have Existing</div>
                              <div>Coupler</div>
                            </div>
                          ),
                          selected:
                            decision === couplerDecision.existingCoupler,
                        })
                      }
                      onClick={() =>
                        onStateChanged({
                          decision: couplerDecision.existingCoupler,
                          couplerStyleId: null,
                          couplerOilReady: null,
                        })
                      }
                      widthColumns={4}
                      mdWidthColumns={isNarrowLayout ? 4 : 2}
                    />
                  )}
                {attachmentPoint.compatibleCouplerDecisions.find(
                  (x) => x === couplerDecision.amiTiltRotator
                ) &&
                  showAmiCoupler &&
                  couplerStyles.length > 0 && (
                    <TextMosaic
                      data={
                        new TextMosaicDto({
                          label: (
                            <div>
                              <div>Need a</div>
                              <div>Tilt Rotator</div>
                            </div>
                          ),
                          selected: decision === couplerDecision.amiTiltRotator,
                        })
                      }
                      onClick={() =>
                        onStateChanged({
                          decision: couplerDecision.amiTiltRotator,
                          couplerStyleId: null,
                          couplerOilReady: null,
                        })
                      }
                      widthColumns={4}
                      mdWidthColumns={isNarrowLayout ? 4 : 2}
                    />
                  )}
                {attachmentPoint.compatibleCouplerDecisions.find(
                  (x) => x === couplerDecision.existingTiltRotator
                ) &&
                  couplerStyles.length > 0 && (
                    <TextMosaic
                      data={
                        new TextMosaicDto({
                          label: (
                            <div>
                              <div>Have Existing</div>
                              <div>Tilt Rotator</div>
                            </div>
                          ),
                          selected:
                            decision === couplerDecision.existingTiltRotator,
                        })
                      }
                      onClick={() =>
                        onStateChanged({
                          decision: couplerDecision.existingTiltRotator,
                          couplerStyleId: null,
                          couplerOilReady: null,
                        })
                      }
                      widthColumns={4}
                      mdWidthColumns={isNarrowLayout ? 4 : 2}
                    />
                  )}
                {attachmentPoint.compatibleCouplerDecisions.find(
                  (x) => x === couplerDecision.notSpecified
                ) &&
                  showDecideLater && (
                    <TextMosaic
                      data={
                        new TextMosaicDto({
                          label: (
                            <div>
                              <div>Decide</div>
                              <div>Later</div>
                            </div>
                          ),
                          selected: decision === couplerDecision.notSpecified,
                        })
                      }
                      onClick={() =>
                        onStateChanged({
                          decision: couplerDecision.notSpecified,
                          couplerStyleId: null,
                          couplerOilReady: null,
                        })
                      }
                      widthColumns={4}
                      mdWidthColumns={isNarrowLayout ? 4 : 2}
                    />
                  )}
              </MosaicWall>
            </div>
          </Fragment>
        )}
      </div>
    </div>
    {decision && (
      <ReviewQuoteExistingCouplerSelection
        show={showExistingCouplerSelection}
        couplerStyles={couplerStyles}
        defaultCouplerType={defaultCouplerType}
        decision={decision}
        couplerStyleId={couplerStyleId}
        onCouplerStyleIdChanged={(couplerStyleId) => {
          onStateChanged({ couplerStyleId, couplerOilReady: null });
        }}
        couplerOilReady={couplerOilReady}
        onCouplerOilReadyChanged={(couplerOilReady) => {
          onStateChanged({ couplerOilReady });
        }}
        productGroupIdsPerType={productGroupIdsPerType}
        isNarrowLayout={isNarrowLayout}
        currentManufacturer={currentManufacturer}
      />
    )}
  </Fragment>
);

ReviewQuoteCouplerDecisionModalContent.defaultProps = {
  productGroupIdsPerType: [],
  showAmiCoupler: true,
  showDecideLater: true,
};

ReviewQuoteCouplerDecisionModalContent.propTypes = {
  anyCouplerAffected: PropTypes.bool.isRequired,
  decision: PropTypes.string,
  couplerStyleId: PropTypes.string,
  defaultCouplerType: PropTypes.string,
  showExistingCouplerSelection: PropTypes.bool.isRequired,
  couplerStyles: PropTypes.arrayOf(PropTypes.instanceOf(QuoteCouplerStyle))
    .isRequired,
  onStateChanged: PropTypes.func.isRequired,
  productGroupIdsPerType: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      productGroupIds: PropTypes.arrayOf(PropTypes.string).isRequired,
    })
  ),
  showAmiCoupler: PropTypes.bool,
  showDecideLater: PropTypes.bool,
  isNarrowLayout: PropTypes.bool,
  currentManufacturer: PropTypes.string,
};

export { ReviewQuoteCouplerDecisionModalContent };
